import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import React from "react";
import soccerSchoolImage from '../imgs/soccer-school.jpg';

const SoccerSchool: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Soccer School | Ashridge Park FC</title>
        <meta name="description" content="Join Ashridge Park FC's Soccer School for children in year 1. Our fun, inclusive sessions focus on basic skills, teamwork, and a love for football." />
      </Helmet>
      
      <Container className="p-3 my-4">
        <Row className="align-items-center g-4">
          {/* Left side - Content */}
          <Col lg={6}>
            <div className="soccer-school-content">
              <Badge bg="primary" className="mb-3 px-3 py-2 fs-6">Children in Year 1</Badge>
              <h1 className="mb-4 display-5 fw-bold" style={{ color: '#254E97' }}>
                SOCCER SCHOOL
              </h1>
              
              <p className="lead mb-4">
                Ashridge Park FC's Soccer School is designed for children in year 1, providing a fun and engaging introduction to football. Our sessions focus on developing basic skills, coordination, and a love for the game in a safe and supportive environment.
              </p>

              <Card className="border-0 shadow-sm">
                <Card.Body className="bg-light">
                  <h3 className="h5 mb-3" style={{ color: '#254E97' }}>
                    <i className="bi bi-calendar3"></i> Session Details
                  </h3>
                  <div className="session-details">
                    <div className="detail-item mb-3">
                      <div className="fw-bold text-primary">When</div>
                      <div>Saturdays, 9:00 AM - 10:00 AM</div>
                    </div>
                    <div className="detail-item mb-3">
                      <div className="fw-bold text-primary">Where</div>
                      <div>St. Crispins School, Wokingham</div>
                    </div>
                    <div className="detail-item mb-3">
                      <div className="fw-bold text-primary">Contact</div>
                      <div>Kevin McGill - <a href="tel:07751304757">07751 304 757</a></div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>

          {/* Right side - Image */}
          <Col lg={6}>
            <div className="soccer-school-image">
              <Card className="border-0 shadow-lg">
                <div className="image-container">
                  <Card.Img 
                    src={soccerSchoolImage} 
                    alt="Soccer School training session" 
                    className="rounded-3"
                    style={{ 
                    //   height: '650px', 
                      objectFit: 'cover',
                      filter: 'brightness(1.05) contrast(1.1)'
                    }}
                  />
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default SoccerSchool;